import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const StatusContainer = styled.div`
  width: fit-content;
  text-transform: uppercase;
`
